import { gql } from '@apollo/client'

export const EDIT_RESULT_EVENT_SAMPLE = gql`
  mutation EditResultEventSample($inputData: EditResultEventSampleInput!) {
    editResultEventSample(inputData: $inputData) {
      id
    }
  }
`
